import { render, staticRenderFns } from "./classical-class-observation.vue?vue&type=template&id=04c173de"
import script from "./classical-class-observation.vue?vue&type=script&lang=js"
export * from "./classical-class-observation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports